module.exports = __webpack_public_path__ + "img/icon_package_blue.1144e6f2.png";